import { useQuery } from "@tanstack/react-query";
import { PalletService } from "src/services/pallets";
import { queryKeys } from "src/constants";

const usePalletStats = (palletService: PalletService) => {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.palletStats(),
    queryFn: () => palletService.getPalletStats()
  });

  return {
    casesReady: data?.casesReady ?? 0,
    palletsBuilding: data?.palletsBuilding ?? 0,
    palletsComplete: data?.palletsComplete ?? 0,
    palletsInTransit: data?.palletsInTransit ?? 0,
    palletsBookedIn: data?.palletsBookedIn ?? 0,
    isLoading
  };
};

export { usePalletStats };
